export default "__VITE_ASSET__phYnuOm$__"